import React from 'react';
type SectionHeadingProps = {
  title: string;
  subtitle?: React.ReactNode;
  id?: string;
};
export function SectionHeading({
  title,
  subtitle,
  id
}: SectionHeadingProps) {
  return <div className="text-center" data-id="element-60" data-mp="3f1c440gibp0y">
      <h2 id={id} className="mx-auto max-w-2xl text-3xl font-extrabold uppercase leading-[1.05] text-white md:text-[2.5rem]" data-id="element-61" data-mp="3f2dqv26vxzyi">{title}</h2>
      <div className="mx-auto mt-4 h-1 w-14 bg-accent-500" aria-hidden="true" data-id="element-62" data-mp="3k29mad1ioj2g" />
      {subtitle && <div className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-carbon-300 md:text-[17px]" data-id="element-63" data-mp="bmgeqnp5yhxj">{subtitle}</div>}
    </div>;
}